import ItemTextil from "./ItemTextil";

export default ItemTextil;